import { createSlice } from "@reduxjs/toolkit";
import { addQuery } from "helpers/utis";
import { api } from "service/api";
import { ProjectApi } from "service/apiVariables";
import { Toast } from "service/toast";
import { setLoader } from "./loader";

export const MasterQuantitySlice = createSlice({
  name: "Project Master Quantity",
  initialState: {
    projects: {
      data_list: [],
      pageMeta: {},
    },
    inActiveProjects: [],
    activeProjectColumn: [],
    projectDetails: "",
    isLoading: false,

    // dropdown options
    activeRegionOptions: [],
    activeWingOptions: [],
    activeLocationOptions: [],

    inactiveRegionOptions: [],
    inactiveWingOptions: [],
    inactiveLocationOptions: [],

    // selected filters
    activeRegion: null,
    inactiveRegion: null,
    activeWing: null,
    inactiveWing: null,
    activeLocation: null,
    inactiveLocation: null,

    // applied filters for active list
    activeAppliedFilters: {
      search: "",
      region: "",
      wings: "",
      work_location: "",
    },
  },
  reducers: {
    saveProjects: (state, action) => {
      state.projects = action.payload || {
        data_list: [],
        pageMeta: {},
      };
      state.isLoading = false;
    },

    saveInactiveProjects: (state, action) => {
      state.inActiveProjects = action.payload;
      state.isLoading = false;
    },

    saveProjectDetail: (state, action) => {
      state.projectDetails = action.payload;
      state.isLoading = false;
    },

    setActiveProjectColumn: (state, action) => {
      state.activeProjectColumn = action.payload;
    },

    setMasterQuantityLoading: (state, action) => {
      state.isLoading = action.payload;
    },

    saveActiveRegionOptions: (state, action) => {
      state.activeRegionOptions = action.payload || [];
    },
    saveActiveWingOptions: (state, action) => {
      state.activeWingOptions = action.payload || [];
    },
    saveActiveLocationOptions: (state, action) => {
      state.activeLocationOptions = action.payload || [];
    },

    saveInactiveRegionOptions: (state, action) => {
      state.inactiveRegionOptions = action.payload || [];
    },
    saveInactiveWingOptions: (state, action) => {
      state.inactiveWingOptions = action.payload || [];
    },
    saveInactiveLocationOptions: (state, action) => {
      state.inactiveLocationOptions = action.payload || [];
    },

    setSelectedActiveRegion: (state, action) => {
      state.activeRegion = action.payload;
    },
    setSelectedInactiveRegion: (state, action) => {
      state.inactiveRegion = action.payload;
    },
    setSelectedActiveWing: (state, action) => {
      state.activeWing = action.payload;
    },
    setSelectedInactiveWing: (state, action) => {
      state.inactiveWing = action.payload;
    },
    setSelectedActiveLocation: (state, action) => {
      state.activeLocation = action.payload;
    },
    setSelectedInactiveLocation: (state, action) => {
      state.inactiveLocation = action.payload;
    },

    setActiveAppliedFilters: (state, action) => {
      state.activeAppliedFilters = action.payload;
    },

    clearActiveAppliedFilters: (state) => {
      state.activeAppliedFilters = {
        search: "",
        region: "",
        wings: "",
        work_location: "",
      };
      state.activeRegion = null;
      state.activeWing = null;
      state.activeLocation = null;
    },
  },
});

export const {
  saveProjects,
  saveInactiveProjects,
  setActiveProjectColumn,
  saveProjectDetail,
  setMasterQuantityLoading,

  saveActiveRegionOptions,
  saveActiveWingOptions,
  saveActiveLocationOptions,
  saveInactiveRegionOptions,
  saveInactiveWingOptions,
  saveInactiveLocationOptions,

  setSelectedActiveRegion,
  setSelectedInactiveRegion,
  setSelectedActiveWing,
  setSelectedInactiveWing,
  setSelectedActiveLocation,
  setSelectedInactiveLocation,

  setActiveAppliedFilters,
  clearActiveAppliedFilters,
} = MasterQuantitySlice.actions;

export default MasterQuantitySlice.reducer;

export const getSingleProjectAct = (query) => (dispatch) => {
  const baseConfig = ProjectApi.getSingleProjectApi;

  const apiConfig = {
    method: baseConfig.method,
    baseURL: baseConfig.baseURL,
    api: baseConfig.api(query.project_id, query.work_location),
  };

  dispatch(setLoader(true));
  dispatch(setMasterQuantityLoading(true));

  return new Promise((resolve, reject) => {
    api(apiConfig)
      .then(({ data }) => {
        dispatch(saveProjectDetail(data));
        dispatch(setLoader(false));
        dispatch(setMasterQuantityLoading(false));
        resolve(data);
      })
      .catch(({ message }) => {
        dispatch(setLoader(false));
        dispatch(setMasterQuantityLoading(false));
        reject(Toast({ type: "error", message }));
      });
  });
};

export const getAllProjectAct = (query) => (dispatch) => {
  ProjectApi.getAllProjectApi.addQuery = query;
  addQuery(query || {}, ProjectApi.getAllProjectApi);

  dispatch(setLoader(true));
  dispatch(setMasterQuantityLoading(true));

  return new Promise((resolve, reject) => {
    api({ ...ProjectApi.getAllProjectApi })
      .then(({ data }) => {
        dispatch(
          saveProjects({
            data_list: data?.data_list || [],
            pageMeta: data?.pageMeta || {},
          }),
        );
        dispatch(setLoader(false));
        dispatch(setMasterQuantityLoading(false));
        resolve(data);
      })
      .catch(({ message }) => {
        dispatch(setLoader(false));
        dispatch(setMasterQuantityLoading(false));
        reject(Toast({ type: "error", message }));
      });
  });
};

// region dropdown
const mapRegionOption = (item) => ({
  label: item.region_name || item.label || item.name,
  value: item.region_id || item.value || item.id,
});

const getRegionListFromResponse = (data) => {
  return data?.data || data?.data_list || data || [];
};

const buildRegionOptions = (data) => {
  const regionList = getRegionListFromResponse(data);
  return regionList.map(mapRegionOption);
};

export const getActiveRegionListAct = () => async (dispatch) => {
  dispatch(setLoader(true));

  try {
    const { data } = await api({ ...ProjectApi.getRegionsApi });

    const options = buildRegionOptions(data);

    dispatch(saveActiveRegionOptions(options));
    dispatch(setLoader(false));

    return options;
  } catch (error) {
    const message = error?.message || "Failed to fetch regions";

    dispatch(setLoader(false));
    Toast({ type: "error", message });

    throw error;
  }
};
// existing common api
export const getWingsProjectAct = (type, body) => () => {
  ProjectApi.getWingsApi.type = type;
  addQuery(body || {}, ProjectApi.getWingsApi);

  return new Promise((resolve, reject) => {
    api({ ...ProjectApi.getWingsApi })
      .then((data) => resolve(data))
      .catch(({ message }) => reject(Toast({ type: "error", message })));
  });
};

// wing dropdown
export const getActiveWingListAct =
  (query = {}) =>
  (dispatch) => {
    return dispatch(getWingsProjectAct("wings", query)).then((response) => {
      const rawList = response?.data || response?.data_list || [];
      const options = rawList.map((item) => ({
        label: item.wings_name || item.wing_name || item.label || item.name,
        value: item.wings_id || item.wing_id || item.value || item.id,
      }));

      dispatch(saveActiveWingOptions(options));
      return options;
    });
  };

// work location dropdown
export const getActiveLocationListAct =
  (query = {}) =>
  (dispatch) => {
    return dispatch(getWingsProjectAct("area", query)).then((response) => {
      const rawList = response?.data || response?.data_list || [];
      const options = rawList.map((item) => ({
        label:
          item.area_name ||
          item.work_location_name ||
          item.location_name ||
          item.label ||
          item.name,
        value:
          item.work_area_id ||
          item.work_location_id ||
          item.location_id ||
          item.value ||
          item.id,
      }));

      dispatch(saveActiveLocationOptions(options));
      return options;
    });
  };
